<template>
    <div  ref="div" class="vis--wrapper--intro">
    </div>
</template>

<script>
        
    import Legend from './Legend.vue';
    import { mapState } from 'vuex';

    import { 
        json as d3Json,
        select as d3Select,
        selectAll as d3SelectAll,
        scaleLinear as d3ScaleLinear,
        extent as d3Extent,
        nest as d3Nest,
        ascending as d3Ascending,
        scaleSequential as d3ScaleSequential,
        interpolateCool as d3InterpolateCool,
        axisTop as d3AxisTop,
        format as d3Format,
    } from 'd3';
import { clearTimeout } from 'timers';

    export default {
        name: 'LineStacking',
        components: {
            Legend
        },
        data() {
            return {
                svg: null,
                svgWrapper: null,
                container: null,
                transitionDuration: 250,
                popupTimeout: 250,
                margin: {
                    left: 20,
                    right: 20,
                    top: 20,
                    bottom: 20,
                },
                width: null,
                height: null,
                radius: 300,
                xScale: null,
                xAxis: null,
                dataNesting: null,
                gradScale: null,
                groupDefs: null,
                groupSpacing: 20,
                lineSpacing: 2,
                groupAxis: null,
                groupLines: null,
                gOne: null
            }
        },
        props: ['statements', 'svgHeight', 'content', 'snippet', 'pos', 'timeout', 'highlight', 'paragraphActive', 'dataActive', 'dataset'],
        computed: {
            ...mapState(['introVisible', 'dataFetched', 'nodesAvailable', 'sidebarVisible', 'storyActive', 'popupActive', 'storyCount', 'snippetCurrent', 'visRendered', 'storyActive', 'datasetCurrent']),
            clientWidth: () => {
                return d3Select('#app').node().getBoundingClientRect().width;
            },
            clientHeight: () => {
                return d3Select('#app').node().getBoundingClientRect().height;
            }
        },
        watch: {
            snippetCurrent() {
                if (this.timeout != null) {
                    clearTimeout(this.timeout);
                }
                this.dispatchVisRendered(false);

            },
            storyActive() {
                this.dispatchVisRendered(false);

                if (this.timeout != null) {
                    clearTimeout(this.timeout);
                }

                this.updateVis()
            },
            dataset() {
                this.dispatchVisRendered(false);
                this.updateVis()
            }
        },
        methods: {
            dispatchTimeout(state) {
                this.$store.dispatch("SET_TIMEOUT", state);
            },
            dispatchPopupPos(state) {
                this.$store.dispatch("SET_POPUP_POS", state);
            },
            dispatchVisRendered(state) {
                this.$store.dispatch("SET_VIS_RENDERED", state);
            },
            dispatchSvgHeight(state) {
                this.$store.dispatch("SET_SVG_HEIGHT", state);
                this.svgWrapper.attr('height', state)
            },
            updateVis() {
                this.requestData(this.dataset);
            },
            fetchPositions() {
                let nodeCourse = d3Select(`rect#id-${this.snippet.pos[0]}`);
                let nodeYear = d3Select(`text#id-${this.snippet.pos[1]}`);
                let course, year;

                if (nodeCourse.node() != null && nodeYear.node() != null) {
                    course = nodeCourse.node().getBoundingClientRect();
                    year = nodeYear.node().getBoundingClientRect();

                    let distToTop = parseFloat(course.top) - this.radius;
                    let distToLeft = parseFloat(year.left) - this.radius;
                    const pos = [distToLeft, distToTop];

                    // this.dispatchPopupPos(pos); 
                    this.dispatchVisRendered(true);
                }

            },
            init() {
                d3Select('vis--svg--intro').remove();

                this.height = this.clientHeight - this.margin.top - this.margin.bottom;
                this.width = (this.clientWidth) - this.margin.left - this.margin.right;

                this.container = d3Select('.vis--wrapper--intro')

                this.svgWrapper = this.container.append('svg')
                    .attr('id', 'vis--svg--intro')
                    .attr('width', this.clientWidth)
                    .attr('height', this.clientHeight)

                this.svg = this.svgWrapper
                    .append("g")
                    .attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")");

                this.xScale = d3ScaleLinear()
                    .domain([this.statements.startYear, + this.statements.endYear])
                    .rangeRound([0, this.width]);

                this.groupDefs = this.svg.append("g")
                    .attr("id", "groupDefs");

                this.groupLines = this.svg.append("g")
                    .attr("id", "groupLines");

                this.gOne = this.groupDefs.append("defs")
                    .append("linearGradient")
                    .attr("id", "group-one")
                    .attr("x1", '0%')
                    .attr("y1", '0%')
                    .attr("x2", '100%')
                    .attr("y2", '0%');

                this.gOne.append("stop")
                    .attr("offset", 0)
                    .attr("stop-color", "#ffffff")
                    .attr("stop-opacity", 0);

                this.gOne.append("stop")
                    .attr("offset", 1)
                    .attr("stop-color", "#2ECC40")
                    .attr("stop-opacity", 1);

                this.requestData(this.dataset);
            },
            requestData(url) {
                d3Json(url)
                    .then(data => {
                        this.transformData(data);
                    })
            },
            transformData(data) {

                let curGrad, min, max, gradColor;

                this.gradScale = d3ScaleLinear()
                    .range([0,1]);

                this.gradColorScale = d3ScaleSequential()
                    .domain([1, 100])
                    .interpolator(d3InterpolateCool);
                
                data.forEach((e,groupI) => {
                    e.values.forEach(d => {

                        if (d.values.length > 2) {

                            curGrad = this.groupDefs.append("defs")
                                .append("linearGradient")
                                .attr("id", "g"+groupI+'-'+d.key)
                                .attr("x1", '0%')
                                .attr("y1", '0%')
                                .attr("x2", '100%')
                                .attr("y2", '0%');

                            min = +d.values[0].year+.02;

                            max = +d.values[d.values.length-1].year;

                            this.gradScale.domain([min,max]);

                            d.values.forEach((g,j) => {

                                if (j === 1) {
                                    gradColor = 'red';
                                } else {
                                    gradColor = this.gradColorScale(g.year - min);
                                }

                                curGrad.append("stop")
                                    .attr("offset", this.gradScale(g.year))
                                    .attr("stop-color", gradColor)
                                    .attr("stop-opacity", 1);

                                curGrad.append("stop")
                                    .attr("offset", this.gradScale(g.year)+.001)
                                    .attr("stop-color", "#ccc")
                                    .attr("stop-opacity", .05);

                            })
                        }
                    })
                });

                /////// Axis Domain Transform
                this.xScale.domain([1990,2020]);
                
                this.drawLines(data);
            },
            drawLines(data) {

                this.lineSpacing = 3;

                var totalVisHeight = (this.margin.top + this.margin.bottom) + (this.groupSpacing*(data.length-1)) + (data[data.length-1].groupPosition + data[data.length-1].groupSize) * this.lineSpacing;

                if (totalVisHeight < window.innerHeight) {
                    var givenHeight = Math.ceil((window.innerHeight - totalVisHeight) / (data[data.length-1].groupPosition + data[data.length-1].groupSize));

                    // if (givenHeight >= 2) {
                        this.lineSpacing = givenHeight+2;
                    // }
                }

                this.groupLines.selectAll(".areaGroup").remove();

                this.classGroups = this.groupLines.selectAll(".areaGroup")
                    .data(data)
                    .enter()
                    .append("g")
                    .attr('class', 'areaGroup')
                    .attr('transform', (d,i) => { return 'translate(0,'+(d.groupPosition*this.lineSpacing+this.groupSpacing*i)+')'; })
                    .selectAll(".linePath")
                    .data(d => { return d.values; }, function(d) { return d.key; })
                    .enter()
                    .append('rect')
                    .attr('class', 'linePath')
                    .attr('id', d => { return `id-${d.key}`; })
                    .attr('x', d => { return this.xScale(d.values[0].year); })
                    .attr('y', d => { return d.yPos*this.lineSpacing; })
                    .attr('width', 0)
                    .attr('height', 1.25)
                    .attr("fill", function(d) {
                        if (d.values.length == 2) {
                            return  "url(#group-one)"
                        } else {
                            return "url(#g"+d.values[0].groupI+"-"+d.key+")" // d.values[0].groupI
                        }
                    })
                    .attr('stroke', 'rgba(0,0,0,0)')
                    .attr('stroke-width', '2px')
                    .transition()
                    .delay((d,i) => { return i * d.values.length * 500 })
                    .duration(5000)
                    .attr('width', d => { 
                        const val = this.xScale(d.values[d.values.length-1].year)-this.xScale(d.values[0].year);
                        return val < 0 ? 0 : val; })

            },
        },
        componenDidUpdate() {
        },
        mounted() {
            this.init();
            this.updateVis();
        }
    }
</script>

<style lang="scss">
    @import '../assets/style/main.scss';

    .vis {
        &--wrapper--intro {
            -ms-overflow-style: none;
            width: 100%;
            height: 100%;
            position: fixed;
            top: 0;
            left: 0;
            transition: all $time-m ease-in-out;

            // &.left {
            //     transform: translateX($sidebar-width);
            //     transition: all $time-m ease-in-out;
            // }

            // &.right {
            //     transform: translateX(-$sidebar-width);
            //     transition: all $time-m ease-in-out;
            // }
            
        }
    }

    /*---------CSS For Axis-----------*/

    .axis .domain{
    stroke: none;
    }

    rect {
        opacity: 1;
        transition: opacity $time-m ease-in-out;
        &.inactive {
            opacity: .05;
            transition: opacity $time-m ease-in-out;
        }
    }


    /*---------CSS For Hover Text-----------*/

    .hoverText{
    pointer-events: none;
    font-family: 'IBM Plex Mono', monospace;
    font-style: italic;
    }
    .bgHoverRect{
    fill: white;
    }
    .fgHoverText{
    fill: black;
    stroke: none;
    font-size: .8em;
    }

    g.tick > text {
        font-family: 'IBM Plex Mono';
        transform: translateY(-2px);
    }

    /*---------Label Text-----------*/

    .groupLabelsText{
    font-size: $font-size-s;
    text-transform: uppercase;
    font-family: 'IBM Plex Mono';
    letter-spacing: 1.5px;
    /*transform: skew(-10deg);*/
    }
    
</style>
